<template>
    <div class="gdm_top">
        <!--轮播图-->
        <div id="myCarousel" class="gdmt_pic">
            <div  id="main_flexslider">
                <el-carousel trigger="click" height="263px">
                    <el-carousel-item v-for="item in topCarousel" :key="item.id">
                        <a target="_blank" :href="item.url"><img :src="item.imgUrl" width="716" height="263" /></a>
                    </el-carousel-item>
                </el-carousel>
            </div>
        </div>

        <div class="gdmt_login">
            <div class="gdmtl_title">
                <a href="javascript:;" @click="LoginTabsSwitch=1" :class="{ gdmtl_title_sel: LoginTabsSwitch===1 }">学&nbsp;&nbsp;员</a>
                <a href="javascript:;" @click="LoginTabsSwitch=2" :class="{ gdmtl_title_sel: LoginTabsSwitch===2 }">管理员</a>
            </div>
            <!--学员-->
            <div class="gdmtl_main" style="padding-top: 20px;" v-show="LoginTabsSwitch===1">
                <div class="gdmtl_main_text">
                    <span class="gdmtl_main_user_ico"></span>
                    <input type="text" v-model.trim="usernameS" class="gdmtl_main_textbox" placeholder="用户名/身份证号/手机号">
                </div>
                <div class="gdmtl_main_text">
                    <span class="gdmtl_main_pwd_ico"></span>
                    <input type="password" v-model="passwordS" class="gdmtl_main_textbox" placeholder="密码">
                </div>
                <div class="gdmtl_main_btn"><input type="submit"  @click="loginS" value="登  录"></div>
                <div class="gdmtl_main_other">
                    <router-link  target="_blank" :to="{ path: '/Register'}" class="gdmtl_main_other_reg">注册帐号</router-link>
                    <router-link  target="_blank" :to="{ path: '/findByMobile'}" class="gdmtl_main_other_for">忘记密码</router-link>
                </div>
            </div>
            <!--管理员-->
            <div class="gdmtl_main" style="padding-top: 20px;display: none" v-show="LoginTabsSwitch===2">
                <div class="gdmtl_main_select" style="margin-bottom: 12px;">
                    <span>请选择：</span>
                    <div>
                        <select id="loginType" v-model.number="manageLoginType">
                            <option value="1">培训教学管理</option>
                            <option value="2">考试考务管理</option>
                        </select>
                    </div>
                </div>
                <div class="gdmtl_main_text" style="margin-bottom: 12px;">
                    <span class="gdmtl_main_user_ico"></span>
                    <input type="text" v-model.trim="adminUserName" class="gdmtl_main_textbox" placeholder="用户名">
                </div>
                <div class="gdmtl_main_text" style="margin-bottom: 12px;">
                    <span class="gdmtl_main_pwd_ico"></span>
                    <input type="password" v-model="adminPassword" class="gdmtl_main_textbox" placeholder="密码">
                </div>
                <div class="gdmtl_main_btn"><input type="submit" id="login" @click="teachManageLogin" value="登  录"></div>
            </div>
        </div>

        <!--选班弹出层-->
        <el-dialog  :visible.sync="loginSuccess" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" >
            <div class="gdjc_disk" >
                <div class="gdjcd_title">请选择您所要参加的培训班：<a href="JavaScript:;" @click="stepInto(0)">进入学习中心</a> </div>
                <div class="gdjcd_main">
                    <ul>
                        <li v-for="(item,index) in gdjcwsTrainings" :key="item.id">
                            {{ index+1 }}.&nbsp;{{ item.name }}
                            <a href="javascript:;" @click="stepInto(item.id)" v-if="item.inside==1" class="gdjcd_main_over">进入培训</a>
                            <a href="javascript:;" @click="confirmAdd(item.remark,item.id)" v-else >参加培训</a>
                        </li>
                    </ul>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {teachManageLogin, getServerNowTime,login,getRecommendList,trainings,addUser2Training,trainingOfUser,apiCloudInstance} from '../api/api';
    import md5 from 'crypto-js/md5'
    import jsonp from 'jsonp';

    export default {
        data () {
            return {
                trainingType:103142,
                LoginTabsSwitch: 1,
                usernameS: '',
                passwordS: '',
                manageLoginType: 1,
                adminUserName: '',
                adminPassword: '',
                topCarousel:null,
                loginSuccess:false,
                gdjcwsTrainings:[],
                trainings:[],
                token:''
            }
        },
        mounted() {
            /*获取轮播图*/
            getRecommendList({
                pageNum: 0,
                pageSize: 5,
                posf: 24,
                posc: null,
                order: 1
            }).then((response) => {
                this.topCarousel = response.data.data.list;
            }),
            /*查询广东基层的13个培训班*/
            trainings({
                trainingType:this.trainingType
            }).then((response) => {
                this.gdjcwsTrainings = response.data.list;
            })

        },
        computed: {
            // 使用对象展开运算符将 getters 混入 computed 对象中
            /*...mapGetters([
                'userInfo'
                // ...
            ]),*/
        },
        methods: {
            loginS() {
                if (this.usernameS && this.usernameS) {
                    login({
                        username: this.usernameS,
                        password: md5(this.passwordS).toString()
                    }).then((response) => {
                        const data = response.data;
                        if (data.userInfo) {
                            this.userInfo = data.userInfo;
                            this.token=data.token;
                            if (this.userInfo.id > 0) {
                                window.location.href = process.env.VUE_APP_WEB30_URL + "usercenter/index?token="+this.token.toString()+'&logoutUrl='+window.location.href;
                                /*查询用户已经参加的培训班（不包含已过时的）*/
                                // var params={excludeExpire:true,trainingWay:1};
                                // trainingOfUser(this.userInfo.id,params).then((response) => {
                                //     this.trainings = response.data.list;
                                //     for (let i = 0; i <this.trainings.length ; i++) {
                                //         for (let j = 0; j < this.gdjcwsTrainings.length; j++) {
                                //             if(this.trainings[i].id==this.gdjcwsTrainings[j].id){
                                //                 this.gdjcwsTrainings[j].inside=1;
                                //             }
                                //         }
                                //     }
                                //     this.loginSuccess = true;
                                // })
                            }
                        } else {
                            this.$message.warning(data.msg);
                        }
                    }).catch(() => {
                        this.$message.warning('登录异常！');
                    })
                } else {
                    this.$message.warning('用户名或密码不允许为空！');
                }
            },
            teachManageLogin() {
                if (this.manageLoginType == 1) {
                    teachManageLogin({
                        username: this.adminUserName,
                        password: md5(this.adminPassword).toString()
                    }).then((response) => {
                        let {data} = response
                        if (data.status == 200) {
                            window.location.href = process.env.VUE_APP_TEACH_ADMIN_URL + '?token=' + data.data.token + '&logoutUrl=' + window.location.href;
                        } else {
                            this.$notify.info({
                                title: '消息',
                                message: response.data.msg
                            });
                        }
                    })
                } else {
                    jsonp(process.env.VUE_APP_EXAM_API_URL + '/auth/checklogin?username=' + this.adminUserName + "&password=" + md5(this.adminPassword).toString()
                        , (err, data) => {
                            if (err) {
                                this.$notify.error({
                                    title: '错误',
                                    message: '未知错误！'
                                });
                                return null;
                            } else {
                                if (data.data == true) {
                                    getServerNowTime().then((response) => {
                                        var ts = this.$moment(response.data).valueOf();
                                        let fp = md5(this.adminUserName + ts + "INDEX").toString().toUpperCase();
                                        let reUrl = process.env.VUE_APP_EXAM_MANAGE_API_URL + "/login/oauth2"
                                            + "?" + "turl=" + process.env.VUE_APP_EXAM_MANAGE_API_URL + "/main" //目标地址
                                            + "&" + "eurl=" + window.location.href // 退出登录回调地址
                                            + "&" + "ts=" + ts
                                            + "&" + "from=" + "INDEX"
                                            + "&" + "userName=" + this.adminUserName
                                            + "&" + "fp=" + fp
                                            + "&" + "ec=" + 1;
                                        window.location.href = reUrl;
                                    })
                                } else {
                                    this.$notify.info({
                                        title: '消息',
                                        message: data.message
                                    });
                                }
                            }
                        });
                }
            },
            confirmAdd(remark, trainingId) {
                this.$confirm('简介：' + remark, '请确认是否加入该培训班并开始学习？', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    /*1、添加参培人员到培训班*/
                    apiCloudInstance.defaults.headers.common['Authorization'] = 'Bearer ' + this.token;
                    addUser2Training( trainingId, this.userInfo.id).then((response) => {
                        if (response.data.state == 1) {
                            /*2、跳转到该培训*/
                            this.stepInto(trainingId);
                        } else {
                            this.$alert('添加失败！');
                        }
                    }).catch(() => {
                        this.$alert('添加失败！');
                    })

                }).catch(() => {
                    /*this.$message({
                        type: 'info',
                        message: '已取消'
                    });*/
                });
            },
            stepInto(trainingId){
                if(trainingId==0){
                    window.location.href = process.env.VUE_APP_WEB30_URL + "usercenter/index?token="+this.token.toString()+'&logoutUrl='+window.location.href;
                }else{
                    window.location.href = process.env.VUE_APP_WEB30_URL + "usercenter/index?trainingId=" + trainingId+"&token="+this.token+'&logoutUrl='+window.location.href;
                }
            }
        }


    }
</script>

<style scoped>
    /*弹出层样式*/
    .gdjc_disk{width:100%;position: relative;background: #fff;}
    .gdjcd_title{font-size: 20px;color:#0d71bb;height:44px;line-height: 42px;border-bottom: 2px #0d71bb solid; padding-left: 15px;top:-40px;left:0;width:100%;position: relative;font-family:"微软雅黑";}
    .gdjcd_title a{display: block;width:120px;height: 26px;position: absolute;right: 10px;top:7px;background: #0d71bb;color: #fff;text-align: center;line-height: 25px; font-size: 14px;border-radius: 13px;transition:background .2s ease;-webkit-transition:background .2s ease;-moz-transition:background .2s ease;-o-transition:background .2s ease;}
    .gdjcd_title a:hover{background:#04538e;border-radius: 2px;font-weight: bold;}
    .gdjcd_main{padding:0px 15px;margin-top:-35px; }
    .gdjcd_main ul li{position: relative;width:100%;line-height: 40px;font-size: 14px;height: 40px;padding-right: 100px;text-overflow: ellipsis;overflow: hidden;white-space: nowrap;}
    .gdjcd_main ul li a{display: block;width:100px;height: 26px;position: absolute;right: 0px;top:7px;background: #0d71bb;color: #fff;text-align: center;line-height: 25px; font-size: 14px;border-radius: 13px;transition:background .2s ease;-webkit-transition:background .2s ease;-moz-transition:background .2s ease;-o-transition:background .2s ease;}
    .gdjcd_main ul li a:hover{background:#04538e;border-radius: 2px;font-weight: bold;}

    .gdjcd_main ul li a.gdjcd_main_over{background: #18a95a;}
    .gdjcd_main ul li a.gdjcd_main_over:hover{background: #037e3b;}

</style>